// @flow

import axios from "axios";
import type { Axios } from "axios";

export default class Service {
    static base = "";

    http: Axios;

    constructor() {
        this.http = axios.create({ baseURL: this.constructor.base });
    }

    toSearchParams(object: any) {
        const params = new URLSearchParams();
        this.forEachIn(object, (key, value) => {
            params.append(key, value);
        });

        return params;
    }

    toFormData(object: any) {
        const formData = new FormData();
        this.forEachIn(object, (key, value) => {
            formData.append(key, value);
        });

        return formData;
    }

    forEachIn(object: any, callback: Function) {
        Object.keys(object).forEach(key => {
            let value = object[key];
            if (value !== null && value !== undefined) {
                if (typeof value === "object" && !(value instanceof File))
                    value = JSON.stringify(value);
                callback(key, value);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/Service.js